import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { useClickAway, useKey } from 'react-use';
import { animatedScrollTo, getRect } from '@noths/polaris-client-utils';
import { ANIMATION_DURATION_IN_MS, TOOLTIP_CONTENT_CLASSNAME } from "./constants";
import * as styles from "./styles";
import { Pointer } from "../../../elements/Pointer/Pointer";
/*
  The Tooltip component displays a string of content in an overlay when the component is clicked
*/
export var Tooltip = function Tooltip(_ref) {
  var alignment = _ref.alignment,
    children = _ref.children,
    className = _ref.className,
    content = _ref.content,
    pointerCustomLeftValue = _ref.pointerCustomLeftValue;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isContentOpen = _useState2[0],
    setIsContentOpen = _useState2[1];
  var containerRef = useRef(null);
  var contentRef = useRef(null);
  var toggleContent = function toggleContent(e) {
    e.preventDefault();
    setIsContentOpen(!isContentOpen);
  };
  var closeContent = function closeContent() {
    return setIsContentOpen(false);
  };
  useEffect(function () {
    var isTooltipBelowViewport = isContentOpen && getRect(contentRef.current, 'bottom') >= window.innerHeight;
    if (isTooltipBelowViewport) {
      animatedScrollTo(getRect(containerRef.current, 'top'));
    }
  }, [isContentOpen]);
  useClickAway(containerRef, closeContent);
  useKey('Escape', closeContent);
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    "data-testid": "tooltip-container",
    ref: containerRef,
    $_css: styles.tooltipButtonWrapper
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    "data-alignment": alignment,
    $_css2: styles.tooltipTextButtonWrapper
  }, children({
    onClick: toggleContent
  })), /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: TOOLTIP_CONTENT_CLASSNAME,
    in: isContentOpen,
    nodeRef: contentRef,
    timeout: ANIMATION_DURATION_IN_MS,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(_StyledDiv3, {
    className: className,
    "data-testid": "content-wrapper",
    ref: contentRef,
    role: "status",
    $_css3: styles.tooltipButtonContentContainer
  }, /*#__PURE__*/React.createElement(Pointer, {
    alignment: alignment,
    pointerCustomLeftValue: pointerCustomLeftValue
  }), /*#__PURE__*/React.createElement("div", {
    "data-testid": "content-children-wrapper"
  }, content))));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv2 = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledDiv3 = /*#__PURE__*/_styled3("div").withConfig({
  displayName: "Tooltip___StyledDiv3",
  componentId: "sc-rz9fpj-0"
})(["", ""], function (p) {
  return p.$_css3;
});